import { commonAPI } from '@redux/api/common.api'

import { URLS } from '@constants'
import {
  GETObjectDataParams,
  GETWindowDTO,
  POSTCopyWindowParams,
  POSTWindowParams,
  Window,
} from '@types'

export const windowApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchAllWindows: build.query<Window[], GETObjectDataParams>({
      query: params => ({
        url: URLS.FRONT_CFG + '/window',
        params: {
          searchPattern: params?.searchPattern,
          sort: params?.sort,
        },
      }),
      providesTags: ['AllWindows', 'AllConfigs'],
    }),
    copyWindow: build.mutation<GETWindowDTO, POSTCopyWindowParams>({
      query: windowData => ({
        url: URLS.FRONT_CFG + '/window/copy',
        method: 'POST',
        body: windowData,
      }),
      invalidatesTags: ['Window', 'AllWindows'],
    }),
    fetchWindowById: build.query<GETWindowDTO, number | string>({
      query: id => ({
        url: URLS.FRONT_CFG + `/window/id/${id}`,
      }),
      providesTags: ['SingleWindow', 'AllConfigs'],
    }),
    createWindow: build.mutation<GETWindowDTO, POSTWindowParams>({
      // TODO можно объединить запросы по create и update
      query: window => ({
        url: URLS.FRONT_CFG + '/window',
        method: 'POST',
        body: window,
      }),
      invalidatesTags: ['AllWindows', 'SingleWindow'],
    }),
    updateWindow: build.mutation<GETWindowDTO, POSTWindowParams>({
      query: windowData => ({
        url: URLS.FRONT_CFG + '/window',
        method: 'POST',
        body: windowData,
      }),
      invalidatesTags: ['AllWindows', 'SingleWindow', 'Window'],
    }),
    deleteWindow: build.mutation<GETWindowDTO, number | string>({
      query: id => ({
        url: URLS.FRONT_CFG + `/window/id/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AllWindows'],
    }),
  }),
})

export const {
  useCopyWindowMutation,
  useFetchAllWindowsQuery,
  useFetchWindowByIdQuery,
  useCreateWindowMutation,
  useUpdateWindowMutation,
  useDeleteWindowMutation,
} = windowApi
